import { Button, Card, Col, Grid, message, Row, Space, Spin, Steps, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { ArticleProperties } from "../../../types/blog.type";
import useBreadcrumbs from "../../../hooks/useBreadcrumbs";
import { httpRequest } from "../../../helpers/api";
import { getErrorMessage } from "../../../helpers/errorHandler";
import TitleSection, { Title } from "../../../components/TitleSection";
import { EditOutlined, EyeOutlined } from "@ant-design/icons";
import DetailDetailPost from "./DetailComponents/DetailPost";
import DetailDescriptionPost from "./DetailComponents/DescriptionPost";
import { urlBlog } from "./helpers/urlBlog";
import { BaseResponseProps } from "../../../types/config.type";
import CommentSection from "./DetailComponents/CommentSection";
import { renderTextStatus } from "./helpers/renderTextStatus";
import { UserProperties } from "../../../types/user.type";
import StatisticSharedCard from "../../dashboard/Components/StatisticSharedCard";
import StatisticViewsCard from "../../dashboard/Components/StatisticViewsCard";

export const MAPPING_STEP = {
	"detail-post": 0,
	"description-post": 1,
};
interface RouterParams {
	articleId?: string;
	index?: keyof typeof MAPPING_STEP;
}

export interface PostStepProps {
	articleId?: string;
	post?: ArticleProperties;
	setIsFetch?: React.Dispatch<React.SetStateAction<boolean>>;
}

const DetailPost: React.FC = () => {
	const { setBreadcrumb } = useBreadcrumbs();
	const history = useHistory();
	const [isLoading, setIsLoading] = useState(false);
	const [post, setPost] = useState<ArticleProperties>();
	const { articleId, index = "detail-post" } = useParams<RouterParams>();
	const [isFetch, setIsFetch] = useState(true);
	let url = `${urlBlog}/article/${post?.slug}`;
	const { xs } = Grid.useBreakpoint();

	useEffect(() => {
		if (isFetch) {
			if (articleId) {
				(async () => {
					try {
						setIsLoading(true);
						let { data } = await httpRequest.get<BaseResponseProps<ArticleProperties>>(
							"/articles/" + articleId
						);
						let { data: dataUser } = await httpRequest.get<BaseResponseProps<UserProperties>>(
							"/users/" + data.payload.createdByUserId
						);
						if (data) {
							let bc = [
								{
									label: data.payload.title,
									origin: articleId,
								},
							];
							setBreadcrumb(bc);
							setPost({
								...data.payload,
								user: dataUser?.payload,
							});
							setIsLoading(false);

							console.log("fetched");
						}
					} catch (err) {
						message.error(getErrorMessage(err));
					} finally {
						setIsLoading(false);
					}
				})();
			}

			setIsFetch(false);
		}

		// eslint-disable-next-line
	}, [articleId, index, isFetch]);

	const stepProps: PostStepProps = {
		articleId,
		post,
		setIsFetch,
	};

	return (
		<Row gutter={[16, 16]}>
			<Col
				span={24}
				lg={15}
			>
				<TitleSection
					title={
						<Space>
							<Title>Post Detail</Title>
							<Tag color="blue">{renderTextStatus(post?.status!)?.toUpperCase()}</Tag>
						</Space>
					}
					icon="back"
					rightAction={
						<Space direction="horizontal">
							<a
								href={url}
								target="_blank"
								rel="noopener noreferrer"
							>
								<Button icon={<EyeOutlined />}>View Blog</Button>
							</a>
							<Button
								type="primary"
								icon={<EditOutlined />}
								onClick={() => {
									history.push("/blog-posts/" + articleId + "/edit");
								}}
							>
								Edit Post
							</Button>
						</Space>
					}
				/>
				<Spin spinning={isLoading}>
					<Card
						bordered={false}
						size="small"
					>
						<Space direction="vertical">
							<div className="ant-steps-divider">
								<Steps
									current={MAPPING_STEP[index]}
									style={{ maxWidth: 500 }}
									items={[{ title: "Post Detail" }, { title: "Post Description" }]}
								/>
							</div>
							{index === "detail-post" ? (
								<DetailDetailPost {...stepProps} />
							) : index === "description-post" ? (
								<DetailDescriptionPost {...stepProps} />
							) : (
								<React.Fragment />
							)}
						</Space>
					</Card>
					{post && (
						<div style={{ marginTop: 16, width: "100%" }}>
							<StatisticSharedCard contentType="article" contentId={post.articleId}/>
						</div>
					)}
				</Spin>
			</Col>
			<Col
				span={24}
				lg={9}
			>
				<Spin spinning={isLoading || !post}>
					{post && (
						<CommentSection
							post={post!}
							setIsFetch={setIsFetch}
						/>
					)}
					{post && (
						<div style={{ marginTop: 16, width: "100%" }}>
							<StatisticViewsCard contentType="article" contentId={post.articleId}/>
						</div>
					)}
				</Spin>
			</Col>
		</Row>
	);
};
export default DetailPost;
